import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Confirm } from 'semantic-ui-react';

function DeleteGrowthTrackerScore({ onClick }) {
  const [open, setOpen] = useState(false);

  const openDialog = () => setOpen(true);
  const closeDialog = () => setOpen(false);
  const confirmAction = () => {
    onClick();
    closeDialog();
  };

  return (
    <React.Fragment>
      <Dropdown.Item onClick={openDialog} text="Delete" />
      <Confirm
        open={open}
        onCancel={closeDialog}
        onConfirm={confirmAction}
      />
    </React.Fragment>
  );
}

DeleteGrowthTrackerScore.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default DeleteGrowthTrackerScore;
